'use server'

import { getBearerTokenServerAction } from '@sylveraio/auth-utils/server-only'
import { HUXLEY_API_HEADERS } from '@sylveraio/constants'
import { REVALIDATION_SECONDS } from '@sylveraio/constants'

/**
 * Fetches data from a specified Huxley API endpoint using an authenticated request, intended for server-side use only.
 *
 * @template D - The type of the data returned in the response.
 * @param {string} endpoint - The API endpoint to fetch data from.
 * @param {'GET' | 'POST'} [method='GET'] - The HTTP method to use for the request. Defaults to 'GET'.
 * @param {Record<string, unknown>} [bodyObject] - An optional object containing the request body for 'POST' requests.
 * @returns {Promise<T>} A promise that resolves to the API response.
 * @throws {Error} Throws an error if the response status is 403.
 *
 * @deprecated - use the generated client functions instead
 */
export async function fetchAuthenticatedServerAction<T>(
  endpoint: string,
  method: 'GET' | 'POST' | 'PATCH' = 'GET',
  bodyObject?: Record<string, unknown>,
): Promise<T> {
  const bearerToken = await getBearerTokenServerAction()
  const body = bodyObject ? JSON.stringify(bodyObject) : undefined

  const response = await fetch(
    `${process.env.NEXT_PUBLIC_MONARCH_API_URL}${endpoint}`,
    {
      method,
      body,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        ...HUXLEY_API_HEADERS,
      },
      next: {
        revalidate: REVALIDATION_SECONDS,
      },
    },
  )

  if (response.status === 403) {
    throw new Error('UNAUTHORIZED')
  }

  return response.json() as Promise<T>
}
